import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PostsService } from 'src/app/service/posts.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-post',
  templateUrl: './edit-post.component.html',
  styleUrl: './edit-post.component.scss'
})
export class EditPostComponent {

  constructor(private route: ActivatedRoute, private postsService: PostsService) { }
  details: any;
  id: any;
  otherDetails: Array<any> = [];
  keywords:any;
  ngOnInit(): void {

    this.route.params.subscribe(params => {

      this.keywords = params['keywords'];

      // Main post details
      this.postsService.getPostDetailsByKey(this.keywords)
        .subscribe(res => {

          this.details = res;
          this.id = this.details.id;
          if(Number(this.id)>0){
            this.getOther();
          }

         

        });


      

    });

  }

  getOther(){
    // Other post details
      this.postsService.getPostOtherDetailsByUser(this.id)
        .subscribe(res => {

          this.otherDetails = res.sort(
            (a: {id:number}, b: {id:number}) => a.id - b.id
          );

          console.log(
            "otherDetails",
            this.otherDetails
          );

        });
  }
  /*ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id'];

      this.postsService.getDetailsById(this.id).subscribe(res => {
        this.details = res;

      })

      this.postsService.getIOtherDetailsByMainId(this.id).subscribe(res => {
        //  this.otherDetails = res;
        console.log("this.otherDetails  " + JSON.stringify(res));
        this.otherDetails = res.sort((a:any, b:any) => a.id - b.id);

      })
    });
  }*/

  pageTitle = [
    {
      bgImage: 'assets/img/page-title-bg.jpg',
      title: 'Profile Authentication'
    }
  ]

  savedId: string = 'NO';

  submit(form:any) {

    var postTitle = form.postTitle;
    console.log(postTitle);

    var postDesciption = form.description;
    console.log(postDesciption);

    var keywords = form.keywords;

    let details = {
      'id':Number(this.id),
      'postTitle': postTitle,
      'postDesciption': postDesciption,
      'keywords':keywords

    }

    const uploadFormData = new FormData();
   // uploadFormData.append('file', this.selectedFileVehicelReg);
    uploadFormData.append('details', JSON.stringify(details));
    this.postsService.editDetails(uploadFormData).subscribe(res => {
      var status = res.status;
       Swal.fire({
          title: res.msg,
        }).then((result) => {
          location.reload();

        })
    })



  }

 /* submit(form:any) {

    var postTitle = form.postTitle;
    console.log(postTitle);

    var postDesciption = form.description;
    console.log(postDesciption);

    var keywords = form.keywords;

    let details = {
      'postTitle': postTitle,
      'postDesciption': postDesciption,
      'keywords':keywords

    }

    const uploadFormData = new FormData();
    uploadFormData.append('file', this.selectedFileVehicelReg);
    uploadFormData.append('details', JSON.stringify(details));
    this.postsService.saveDetails(uploadFormData).subscribe(res => {
      var status = res.status;
      if (status == 'success') {
        this.savedId = res.id;
        Swal.fire({
          title: 'Successfully added the main details!',
        }).then((result) => {

        })
      } else {
        this.savedId = "Error";
        Swal.fire({
          title: 'Error with saving the main details!',
        }).then((result) => {

        })
      }
    })



  }*/

  fileSizeInBytes: any;
  public selectedFileVehicelReg: any = File;
  onFileSelectedVehicleReg(event: any) {
    const file = event.target.files[0];
    this.fileSizeInBytes = file.size;
    if (this.fileSizeInBytes > 10485760) {
      Swal.fire({
        title: 'Size of image should be less than 10240kb!',
      }).then((result) => {
      })
    } else {
      this.selectedFileVehicelReg = file;
    }


  }


  saveImageChanges() {
    const uploadFormData = new FormData();
    uploadFormData.append('file', this.selectedFileVehicelReg);
    let details = {
      'id': this.id,

    }
    uploadFormData.append('details', JSON.stringify(details));

    this.postsService.editImage(uploadFormData).subscribe(res => {
      var status = res.status;
      if (status == 'success') {
        Swal.fire({
          title: 'Successfully editted the news image!',
        }).then((result) => {
          location.reload();
        })
      } else {
        Swal.fire({
          title: 'Error with editing the news image!',
        }).then((result) => {

        })
      }
    })
  }


  //*******************Other Details ************* */
  @ViewChild('title') title!: ElementRef;
  @ViewChild('img') OtherImg!: ElementRef<HTMLInputElement>;
  submitOtherDetails(form :any) {
    if (this.savedId == 'NO') {
      Swal.fire({
        title: 'Please saved the main details!',
      }).then((result) => {

      })
    } else {
      let details = {
        'title': form.title,
        'videoLine': form.videoLink,
        'otherDescription': form.otherDescription
      }

      const uploadFormData = new FormData();
      uploadFormData.append('file', this.selectedFileVehicelReg);
      uploadFormData.append('details', JSON.stringify(details));
      this.postsService.saveOtherDetails(uploadFormData).subscribe(res => {
        var status = res.status;
        if (status == 'success') {
          Swal.fire({
            title: 'Successfully added details!',
          }).then((result) => {
            this.title.nativeElement.value = '';
            this.OtherImg.nativeElement.dispatchEvent(new Event('change'));

          })
        } else {
          Swal.fire({
            title: 'Error with saving the details!',
          }).then((result) => {

          })
        }
      })
    }

  }


  deletePost() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        this.postsService.deletePost(this.id).subscribe(res => {
          var status = res.status;
            Swal.fire({
              title: res.msg,
            }).then((result) => {
              if (status == 'success') {
                window.location.href = "/admin/view-all-posts";
              }
             
            })
          
        })
      }
    });

  }

}
